import { Icon, IconProps } from "@chakra-ui/react";

export function ThumbDownIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M17 2v11l4 1V3a1 1 0 0 0-1-1h-3Zm0 11-2 7a2 2 0 0 1-2 2h-.5a1 1 0 0 1-1-1v-3.5a.5.5 0 0 0-.5-.5H6a2 2 0 0 1-2-2.24l1.14-8A2 2 0 0 1 7.13 4H17" />
    </Icon>
  );
}
